import React from "react";
import { Search } from "../containers/search/Search";

export function SearchPage() {
  return <Search/>;
}
